import styled from 'styled-components';

export const MainOuterWrapper = styled.div(
    props => `
        width:100%;
        display: flex;
        background-color: ${props.theme.colors.white.base};
        padding: ${props.theme.spacing.large.l25} ${props.theme.spacing.large.l30};
        border-radius: 1rem;
        margin-top: ${props.theme.spacing.large.l20};
        box-shadow: 0 3px 30px 0 rgba(0,0,0,0.1);
    `
);

export const MainInnerWrapper = styled.div(
    props => `
        width:100%;
        display: flex;
        flex-direction: column;
    `
);

export const BlockHeadWrap = styled.div(
    props => `
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
    `
);

export const BlockHeadTextWrap = styled.div(
    props => `
        width: 80%;
        display: flex;
        flex-direction: column;
    `
);

export const BlockHeadText = styled.p(
    props => `
        font-size: ${props.theme.font.large.font28};
        color: ${props.theme.colors.black.base};
        font-weight: ${props.theme.font.fontWeight.black};
    `
);
export const BlockHeadTextSubheading = styled.p(
    props => `
        font-size: ${props.theme.font.large.font17};
        color: ${props.theme.colors.black.base};
        font-weight: ${props.theme.font.fontWeight.normal};
    `
);

export const BlockSliderWrap = styled.div(
    props => `
        width:20%;
        display: flex;
        align-self: flex-end;
        justify-content: flex-end;
    `
);

export const TopDestCaroIconWrap = styled.div(
    props => `
      width: 100%;
      display: flex;
      justify-content: flex-end;
      padding-top: ${props.theme.spacing.large.l12};
    `
);

export const IconInnerWrapCaro = styled.div(
    props => `
      display: flex;
      width: 6.8rem;
      height: 3rem;
      align-items: center;
      border-radius: 20px;
      box-shadow: 0 1px 6px 0 ${props.theme.colors.black.light2};
      background-color: ${props.theme.colors.white.base};
    `
);

export const LeftIconWrapCaro = styled.div(
    props => `
      width:50%;
      display: flex;
      justify-content: center;
    `
);

export const RightIconWrapCaro = styled.div(
props => `
    width:50%;
    display: flex;
    justify-content: center;
`
);

export const BlockConentWrap = styled.div(
    props => `
        width: 94%;
        display: flex;
        align-items: center;
        padding-top: ${props.theme.spacing.base};
        overflow: auto;
        position:relative;
        margin-left: 15px;
    `
);

export const SuggestedCardList = styled.ul(
    props => `
      width: 100%;
      display: flex;
      list-style-type: none;
      li{
          width:28rem;
        //   height: 24rem;
          padding-top: ${props.theme.spacing.base};
          display: flex;
          margin-right: ${props.theme.spacing.base};
          cursor: pointer;
          flex-direction: column;
      }
    `
);

export const SuggestedImageWrap = styled.div(
    props => `
        width: 100%;
        display: flex;
        img{
            width:26rem;
            height:15rem;
            border-radius: .4rem;
        }
    `
);

export const SuggestedCityText = styled.div(
    props => `
        font-size: ${props.theme.font.large.font17};
        color: ${props.theme.colors.black.base};
        font-weight: ${props.theme.font.fontWeight.bold};
        padding-top: ${props.theme.spacing.base};
    `
);

export const SuggestedCityTextDescription = styled.div(
    props => `
        font-size: ${props.theme.font.large.font13};
        color: ${props.theme.colors.black.base};
        font-weight: ${props.theme.font.fontWeight.normal};
    `
);
